// extracted by mini-css-extract-plugin
export default {"container":"CreateTeam_container__VL1xk","centered":"CreateTeam_centered__EpYwq"};